import * as Api from "./api";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import * as types from "./actionTypes";
import * as eventTypes from "./eventTypes";
import { getKnockoutCriteriaIsLoaded } from "./selectors";

export function loadPartnerKnockoutCriteria(partnerId) {
  return async (dispatch, getState) => {
    const isLoaded = getKnockoutCriteriaIsLoaded(getState(), partnerId);
    if (isLoaded) {
      return;
    }

    try {
      let knockoutCriteria = await dispatch(sendHttpRequest(Api.getKnockoutCriteria(partnerId)));
      dispatch({ type: types.LOAD_OFFER_PARTNER_KNOCKOUT_CRITERIA_SUCCESS, payload: { knockoutCriteria, partnerId } });

      return knockoutCriteria;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function evaluatePartnerKnockoutCriteria(documentId, siteId, partnerId) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          Api.evaluateKnockoutCriteria(documentId, siteId, partnerId),
          "RunningOfferCommand",
          [eventTypes.OFFER_PARTNER_KNOCKOUT_CRITERIA_EXECUTED],
          false
        )
      );
      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
